import { DASHBOARD_REQUEST_FAILED, DASHBOARD_REQUEST_START, DASHBOARD_REQUEST_SUCCESS, DASHBOARD_UPDATE } from "./dashboardTypes"

const initialState = {
    loading: false,
    diamonds: {},
    topups: {},
    users: {},
    admins: {},
    error: ''
}

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case DASHBOARD_REQUEST_START:
            return { ...state, loading: true }
        case DASHBOARD_REQUEST_SUCCESS:
            return {
                ...state,
                diamonds: action.payload.diamonds,
                topups: action.payload.topups,
                users: action.payload.users,
                admins: action.payload.admins,
                loading: false,
                error: ''
            }
        case DASHBOARD_REQUEST_FAILED:
            return { ...state, loading: false, error: action.payload }

        case DASHBOARD_UPDATE:
            return {...state, diamonds: action.payload};
    
        default: return state;
    }
}

export default dashboardReducer;